export default class AdverseEventService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getAdverseEvent(id) {
    return this.$http.get(`/api/ae/${id}`);
  }

  getInjurityProbabilities() {
    return [{
      name: '(+1) Extremely unlikely',
      value: 1
    }, {
      name: '(+2) Unlikely but possible',
      value: 2
    }, {
      name: '(+3) Likely',
      value: 3
    }, {
      name: '(+4) Very Likely',
      value: 4
    }, {
      name: '(+5) Extremely Likely',
      value: 5
    }];
  }

  getInjuritySeverities() {
    return [{
      name: '(+1) None – No symptoms reported.',
      value: 1
    }, {
      name: '(+2) Limited – Symptoms resolve quickly. Does not interfere with normal activities.',
      value: 2
    }, {
      name: '(+3) Moderate – Prolonged symptoms and/or interferes with the ability to perform normal activities.',
      value: 3
    }, {
      name: '(+4) Severe – Permanent injury or unable to perform normal activities.',
      value: 4
    }, {
      name: '(+5) Life threatening.',
      value: 5
    }];
  }

  getOccurrenceLikelihoods() {
    return [{
      name: '(+1) Remote - Only instance recorded',
      value: 1
    }, {
      name: '(+2) Rare - More than one instance (estimated 1 in 1000)',
      value: 2
    }, {
      name: '(+3) Occasional - Multiple instances (estimated 1 in 100)',
      value: 3
    }, {
      name: '(+4) Frequent - Estimated 1 in 10',
      value: 4
    }, {
      name: '(+5) Continuously occurring - More than 10% of the patients',
      value: 5
    }];
  }

  getAnimalSexes() {
    const sexes = [{
      name: 'Male - Neutered / Gelding',
      value: 1
    }, {
      name: 'Male - Intact / Stallion',
      value: 2
    }, {
      name: 'Female - Spayed',
      value: 3
    }, {
      name: 'Female - Intact - Pregnant',
      value: 4
    }, {
      name: 'Female - Intact - Not Pregnant',
      value: 5
    }, {
      name: 'Male - Unknown',
      value: 6
    }, {
      name: 'Female - Unknown',
      value: 7
    }];

    return sexes.sort((a, b) => a.name.localeCompare(b.name));
  }

  getSymptoms() {
    return [
      'Diarrhea',
      'Stomach Upset/Vomiting',
      'Colic (Horse)',
      'Skin/Allergic Reaction',
      'Seizures',
      'Death',
      'Lameness',
      'Accidental Ingestion',
      'Other'
    ];
  }

  getContactTypes() {
    return [
      'Owner',
      'Vet',
      'Other'
    ];
  }

  getStatuses() {
    return [
      'OPEN',
      'CLOSED'
    ];
  }

  getProductsByCompany(companyId) {
    return this.$http.get(`/api/product/signed_by_member/${companyId}`);
  }

  update(adverseEvent) {
    return this.$http.put(`/api/ae/${adverseEvent.AEId}`, {
      ...adverseEvent,
      Contacts: this.orderContacts(adverseEvent.Contacts)
    });
  }

  delete(id) {
    return this.$http.delete(`/api/ae/${id}`);
  }

  create(adverseEvent) {
    return this.$http.post('/api/ae', {
      ...adverseEvent,
      Contacts: this.orderContacts(adverseEvent.Contacts)
    });
  }

  orderContacts(contacts) {
    const tempContacts = [];
    if (!(contacts && contacts.length)) {
      return [];
    }

    const vetIndex = contacts.findIndex(c => c.Relationship === 'Vet');
    const ownerIndex = contacts.findIndex(c => c.Relationship === 'Owner');
    const otherIndex = contacts.findIndex(c => c.Relationship === 'Other');

    if (vetIndex !== -1) {
      tempContacts.push(contacts[vetIndex]);
    }

    if (ownerIndex !== -1) {
      tempContacts.push(contacts[ownerIndex]);
    }

    if (otherIndex !== -1) {
      tempContacts.push(contacts[otherIndex]);
    }

    return tempContacts;
  }

  attest(signature) {
    return this.$http.post('/api/ae/attest', {
      signature
    });
  }
}



// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.service.js